import { call, put, takeLatest } from 'redux-saga/effects';
import { admin, loading, org, toast, modal } from '../types';
import scogo_apis from '../scogo_apis';
import iceberg_apis from '../iceberg_apis';

export function* getAllTagsList(action) {
    const { type, limit = 100, page = 1, query = '', dropdown = false, org_id } = action.payload;
    const skip = (page - 1) * limit;
    const queryParams = { limit, skip };
    if (type && type !== 'ALL') queryParams.type = type;
    if (query) queryParams.q = query;
    if (org_id) queryParams.org_id = org_id;
    if (query) {
        yield put({ type: loading.SEARCH_ALL_TAGS_LOADING, payload: true });
    } else {
        yield put({ type: loading.LIST_ALL_TAGS_LOADING, payload: true });
    }
    try {
        const response = yield call(scogo_apis.admin.getTagsList, {}, {}, queryParams);
        if (response.status === 200) {
            if (dropdown) {
                const dData = response.data.data.map((elem) => ({ value: elem.id, label: elem.text, id: elem.id }));
                yield put({ type: admin.LIST_ALL_DROPDOWN_TAGS_SUCCESS, payload: { data: dData, query } });
            } else {
                yield put({ type: admin.LIST_ALL_TAGS_SUCCESS, payload: { data: response.data.data, type } });
            }
        }
    } catch (error) {
    }
    if (query) {
        yield put({ type: loading.SEARCH_ALL_TAGS_LOADING, payload: false });
    } else {
        yield put({ type: loading.LIST_ALL_TAGS_LOADING, payload: false });
    }
}

export function* getRegionsData(action) {
    const { limit = 100, page = 1, query = '', select = 'id,name,key', appendAtStart = false } = action.payload;
    const queryParams = { limit, page, key: 'city,state', select };
    if (query) queryParams.q = query;

    if (query) {
        yield put({ type: loading.SEARCH_REGION_LOADING, payload: true });
    } else {
        yield put({ type: loading.LIST_ALL_REGION_LOADING, payload: true });
    }
    try {
        const response = yield call(scogo_apis.admin.getRegionsData, {}, {}, queryParams)
        if (response.status === 200) {
            yield put({ type: admin.GET_REGIONS_DATA_SUCCESS, payload: { data: response.data.data, appendAtStart, page } })

        }
    } catch (error) {

    }
    if (query) {
        yield put({ type: loading.SEARCH_REGION_LOADING, payload: false });
    } else {
        yield put({ type: loading.LIST_ALL_REGION_LOADING, payload: false });

    }
};
export function* getDefaultMilestone() {
    try {
        const res = yield call(scogo_apis.admin.getDefaultMilestone, {}, {})
        if (res.status === 200) {
            yield put({ type: admin.GET_DEFAULT_MILESTONES_SUCCESS, payload: res?.data?.data })
        }

    } catch (err) {
        console.log(err)
    }
}

export function* getRemarks(action) {
    const { limit, page, query, category, org_id, dropdown, project_id } = action.payload;
    const queryParams = { limit, page, category, org_id, project_id };
    if (query) queryParams.q = query;
    yield put({ type: loading.GET_REMARKS_LOADING, payload: true });
    try {
        const response = yield call(scogo_apis.admin.getRemarks, {}, {}, queryParams);
        if (response.status === 200) {
            if (dropdown) {
                if (category === 'PO_TERMS') {
                    let remark = '';
                    if (response.data.data.length > 0) {
                        remark = response.data.data[0].master_remark;
                    }
                    yield put({ type: org.GET_PO_TERMS_AND_CONDITIONS_LIST_SUCCESS, payload: { remark, org_id } });
                } else {
                    const d = response.data.data.map((elem) => {
                        const remarkObj = {
                            label: elem.master_remark,
                            id: elem.id,
                            category: elem.category
                        };

                        if (!elem.children || elem.children.length === 0) {
                            remarkObj.value = elem.id;
                        }

                        if (elem.children && elem.children.length > 0) {
                            remarkObj.options = [];

                            const processChildren = (children, parentOptions) => {
                                children.forEach(child => {
                                    const childObj = {
                                        label: child.master_remark,
                                        id: child.id,
                                        category: child.category
                                    };

                                    if (!child.children || child.children.length === 0) {
                                        childObj.value = child.id;
                                    }

                                    if (child.children && child.children.length > 0) {
                                        childObj.options = [];
                                        processChildren(child.children, childObj.options);
                                    }

                                    parentOptions.push(childObj);
                                });
                            };

                            processChildren(elem.children, remarkObj.options);
                        }

                        return remarkObj;
                    });
                    yield put({ type: admin.GET_REMARKS_DROPDOWN_SUCCESS, payload: { category, data: d, query } });
                }
            } else {
                yield put({ type: admin.GET_REMARKS_SUCCESS, payload: { category, data: response.data.data, page } });
            }
        }
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.GET_REMARKS_LOADING, payload: false });
}

export function* getCourierList(action) {
    const { limit, page, query, payload } = action.payload;
    let queryParams = { limit, page };
    if (payload) queryParams = { ...queryParams, ...payload };
    if (query) queryParams.q = query;

    try {
        yield put({ type: loading.GET_COURIER_LIST_LOADING, payload: true })
        const response = yield call(iceberg_apis.courier.list, {}, {}, queryParams)
        if (response.status === 200) {
            let d = response.data.data.map((elem) => ({ value: elem.id, label: elem.name, id: elem.id }))
            yield put({ type: admin.GET_COURIER_LIST_SUCCESS, payload: { data: d, query } })
        }
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.GET_COURIER_LIST_LOADING, payload: false })
}

export function* addNewPincode(action) {
    const { data, formName, onSuccess } = action.payload;
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
    try {
        const response = yield call(scogo_apis.admin.addPincode, {}, {}, {}, {
            container_region_id: data.container_region_id,
            region_key: 'pin',
            region_name: data.pincode,
        });
        if (response.status === 200 || response.status === 201) {
            yield put({ type: admin.ADD_NEW_PINCODE_SUCCESS, payload: response.data?.data });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Pincode Added Successfully' } });
            if (onSuccess) onSuccess(data.pincode);
        } else {
            yield put({ type: admin.ADD_NEW_PINCODE_FAILURE });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: response.data?.messages?.[0] || 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: admin.ADD_NEW_PINCODE_FAILURE });
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export default function* adminSaga() {
    yield takeLatest(admin.LIST_ALL_TAGS_REQUEST, getAllTagsList);
    yield takeLatest(admin.GET_REGIONS_DATA_REQUEST, getRegionsData)
    yield takeLatest(admin.GET_DEFAULT_MILESTONES_REQUEST, getDefaultMilestone)
    yield takeLatest(admin.GET_REMARKS_REQUEST, getRemarks)
    yield takeLatest(admin.GET_COURIER_LIST_REQUEST, getCourierList)
    yield takeLatest(admin.ADD_NEW_PINCODE_REQUEST, addNewPincode)
}
